import { CHARTS_TYPE_ENUM } from "../../../../enums/charts-type.enum";
import METRICS_ENUM, {
  BUSINESS_IMPRESSIONS_DESKTOP_MAPS,
  BUSINESS_IMPRESSIONS_DESKTOP_SEARCH,
  BUSINESS_IMPRESSIONS_MOBILE_MAPS,
  BUSINESS_IMPRESSIONS_MOBILE_SEARCH,
  BUSINESS_DIRECTION_REQUESTS as ACTIONS_DRIVING_DIRECTIONS,
  CALL_CLICKS as ACTIONS_PHONE,
  WEBSITE_CLICKS as ACTIONS_WEBSITE
} from "@/enums/gmbMetricsUpdated.enum.js";
import { i18n } from "@/main";
import { APP_COLORS } from "@/config/app-colors";
import { MakeGMBChartsBase } from "./make-gmb-charts-base";

export class MakeGMBCharts extends MakeGMBChartsBase {
  constructor() {
    super();
    this._colors = {
      violet: APP_COLORS.CHART_PRIMARY,
      violetLight: APP_COLORS.CHART_PRIMARY_LIGHT,
      lime: APP_COLORS.ACCENT,
      green: APP_COLORS.TEAL
    };
    this._chartsConfig = {
      searchMaps: {
        type: CHARTS_TYPE_ENUM.DOUGHNUT,
        labels: [
          `${i18n.t(
            "message.analytics.businessAddresses.chart.searchMaps.label.maps"
          )} - ${i18n.t("message.common.mobile")}`,
          `${i18n.t(
            "message.analytics.businessAddresses.chart.searchMaps.label.maps"
          )} - ${i18n.t("message.common.desktop")}`,
          `${i18n.t(
            "message.analytics.businessAddresses.chart.searchMaps.label.search"
          )} - ${i18n.t("message.common.mobile")}`,
          `${i18n.t(
            "message.analytics.businessAddresses.chart.searchMaps.label.search"
          )} - ${i18n.t("message.common.desktop")}`
        ],
        colors: [
          this._colors.violetLight,
          this._colors.green,
          this._colors.violet,
          this._colors.lime
        ],
        metrics: [
          BUSINESS_IMPRESSIONS_MOBILE_MAPS,
          BUSINESS_IMPRESSIONS_DESKTOP_MAPS,
          BUSINESS_IMPRESSIONS_MOBILE_SEARCH,
          BUSINESS_IMPRESSIONS_DESKTOP_SEARCH
        ]
      },
      maps: {
        type: CHARTS_TYPE_ENUM.BAR,
        labels: [
          {
            text: `${i18n.t(
              "message.analytics.businessAddresses.chart.searchMaps.label.search"
            )} - ${i18n.t("message.common.desktop")}`,
            tooltip: `${i18n.t(
              "message.analytics.businessAddresses.chart.searchMaps.label.search"
            )} - ${i18n.t("message.common.desktop")}`
          },
          {
            text: `${i18n.t(
              "message.analytics.businessAddresses.chart.searchMaps.label.search"
            )} - ${i18n.t("message.common.mobile")}`,
            tooltip: `${i18n.t(
              "message.analytics.businessAddresses.chart.searchMaps.label.search"
            )} - ${i18n.t("message.common.mobile")}`
          },
          {
            text: `${i18n.t(
              "message.analytics.businessAddresses.chart.searchMaps.label.maps"
            )} - ${i18n.t("message.common.desktop")}`,
            tooltip: `${i18n.t(
              "message.analytics.businessAddresses.chart.searchMaps.label.maps"
            )} - ${i18n.t("message.common.desktop")}`
          },
          {
            text: `${i18n.t(
              "message.analytics.businessAddresses.chart.searchMaps.label.maps"
            )} - ${i18n.t("message.common.mobile")}`,
            tooltip: `${i18n.t(
              "message.analytics.businessAddresses.chart.searchMaps.label.maps"
            )} - ${i18n.t("message.common.mobile")}`
          }
        ],
        colors: [
          this._colors.lime,
          this._colors.violet,
          this._colors.green,
          this._colors.violetLight
        ],
        metrics: [
          BUSINESS_IMPRESSIONS_DESKTOP_SEARCH,
          BUSINESS_IMPRESSIONS_MOBILE_SEARCH,
          BUSINESS_IMPRESSIONS_DESKTOP_MAPS,
          BUSINESS_IMPRESSIONS_MOBILE_MAPS
        ]
      },
      clicks: {
        type: CHARTS_TYPE_ENUM.LINE,
        colors: [this._colors.violet],
        metrics: [ACTIONS_WEBSITE]
      },
      directions: {
        type: CHARTS_TYPE_ENUM.LINE,
        colors: [this._colors.violet],
        metrics: [ACTIONS_DRIVING_DIRECTIONS]
      },
      calls: {
        type: CHARTS_TYPE_ENUM.LINE,
        colors: [this._colors.violet],
        metrics: [ACTIONS_PHONE]
      },
      clicksConversion: {
        type: CHARTS_TYPE_ENUM.LINE,
        colors: [this._colors.violet],
        metrics: [ACTIONS_WEBSITE],
        relative: true
      },
      directionsConversion: {
        type: CHARTS_TYPE_ENUM.LINE,
        colors: [this._colors.violet],
        metrics: [ACTIONS_DRIVING_DIRECTIONS],
        relative: true
      },
      callsConversion: {
        type: CHARTS_TYPE_ENUM.LINE,
        colors: [this._colors.violet],
        metrics: [ACTIONS_PHONE],
        relative: true
      }
    };
    this._gmbData = null;
    this.charts = {};
  }
}
